//dependencias
import React, { Component } from 'react';

//componentes
import Actividades from './actividades'

class Index extends Component {

    render(){
        return(
            <div>
                <Actividades />
            </div>
        );
    }

}
export default Index;